<!--
ログイン画面
URL：/login
表示条件：未ログインであること
-->

<template>
  <div>
    <header-title :showAccountInfo="false"></header-title>
    <login-form
      @on-request-login="onRequestLogin"
      @on-reset-password="onResetPassword"
    ></login-form>
  </div>
</template>

<script>
import LoginForm from "../components/login/login-form.vue";
import HeaderTitle from "../components/frame/header-title.vue";
import Api from "@/logic/api/api.js";
import Account from "@/logic/api/account.js";
import AlertContents from "@/logic/common/alert-contents.js";
export default {
  components: {
    "login-form": LoginForm,
    "header-title": HeaderTitle,
  },
  computed: {
    isTosAgree() {
      return this.$store.getters.isTosAgree;
    },
  },
  methods: {
    onRequestLogin(parameters) {
      // ログイン処理を実行する
      this.$store.commit("setWaiting", true);
      Account.signIn(this.$store, parameters.email, parameters.password)
        .then(() => {
          // ログインしているユーザーの情報を取得する
          Api.call("/admin/user", {
            purpose: "VIEW_SELF",
          })
            .then((users) => {
              // しばらくお待ちくださいを閉じる
              this.$store.commit("setWaiting", false);
              // ユーザー情報を共通ストアに反映する
              Account.applyUserInfo(this.$store, users);

              // ログイン履歴に書き込みする
              if (users && users.users && users.users.length >= 1) {
                this.$store.commit("setWaiting", true);
                Api.call("/admin/user/history/insert", {
                  user: users.users[0],
                }).then(() => {
                    this.$store.commit("setWaiting", false);
                  })
                  .catch(() => {
                    this.$store.commit("setWaiting", false);
                  });
              }
              this.$nextTick(() => {
                // 利用規約が同意済みであれば生産情報に移動する
                if (this.isTosAgree) {
                  this.$router.push("/product");
                } else {
                  this.$router.push("/tos");
                }
              });
            })
            .catch(() => {
              Account.signOut(this.$store);
              this.$store.commit("setWaiting", false);
              parameters.message(AlertContents.error("ログインに失敗しました"));
            });
        })
        .catch(() => {
          this.$store.commit("setWaiting", false);
          parameters.message(AlertContents.error("ログインに失敗しました"));
        });
    },
    onResetPassword(parameters) {
      // パスワードの再設定をする
      this.$store.commit("setWaiting", true);
      Api.call("/resetpassword", {
        email: parameters.email,
      })
        .then(() => {
          // しばらくお待ちくださいを閉じる
          this.$store.commit("setWaiting", false);
          parameters.message(
            AlertContents.success("パスワード再発行メールを送信しました")
          );
        })
        .catch(() => {
          // しばらくお待ちくださいを閉じる
          this.$store.commit("setWaiting", false);
          parameters.message(
            AlertContents.error("パスワード再発行メールの送信に失敗しました")
          );
        });
    },
  },
};
</script>

<style scope>
.login {
  max-width: 500px;
}
</style>
